import { useParams } from "react-router-dom";
import { InvoiceDetailContent } from "@/components/financeiro/InvoiceDetailContent";

/**
 * Detalhamento da Medição.
 *
 * **A trilha de navegação é do header**, como em todas as outras telas — não da página. Ela
 * morava aqui porque `useBreadcrumb` não tinha regra para `/financeiro/:id` e caía no fallback de
 * primeiro segmento, mostrando só "Financeiro" no header; a trilha dentro da página cobria a
 * falta, e o resultado eram duas trilhas concorrentes em telas diferentes. Com a regra no lugar,
 * o header resolve navegação e localização, e é lá que o "Financeiro" clicável volta.
 *
 * **Sem botão de voltar e sem card externo** (retorno de QA, 24/08/2026). O caminho de volta é o
 * "Financeiro" da trilha: um botão de seta sem rótulo não diz para onde leva.
 *
 * O card que envolvia todo o conteúdo criava uma segunda moldura em volta de cards que já têm a
 * sua — duas bordas paralelas a poucos pixels uma da outra, sem agrupar nada. As seções internas
 * seguem com os cards próprios.
 */
const MedicaoDetalhe = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <div className="min-h-screen bg-neutral-100 p-4 md:p-6 w-full overflow-x-hidden">
      {id ? (
        <InvoiceDetailContent id={id} />
      ) : (
        <p className="text-neutral-500">Medição não encontrada.</p>
      )}
    </div>
  );
};

export default MedicaoDetalhe;
